import { Component, inject, signal } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ASSIGNMENT_API, provideAssignmentApi } from '../../../api/services/assignment.service';
import { NOTIFICATION_SERVICE } from '../../../shared/notification/notification';
import { Assignment } from '../../../api/app-types/assignment';
import { createErrorNotification, createSuccessNotification } from '../../../shared/notification/notification.factory';
import { hasPermission } from '../../../shared/permissions/permission.func';
import { SessionManagerService } from '../../../shared/storage/session-manager.service';
import { LvrButton } from '../lvr-button/lvr-button';
import { DB_PHASES } from '../../../api/app-types/phase.app';

@Component({
	selector: 'lvr-assignment-draft-delete-dialog',
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	providers: [provideAssignmentApi],
	templateUrl: './assignment-draft-delete-dialog.html',
})
export class AssignmentDraftDeleteDialog {
	private readonly api = inject(ASSIGNMENT_API);
	private readonly dialogRef = inject(MatDialogRef<AssignmentDraftDeleteDialog>);
	private readonly ntfy = inject(NOTIFICATION_SERVICE);
	private readonly transloco = inject(TranslocoService);
	private readonly session = inject(SessionManagerService);
	private readonly data: { assignment: Assignment } = inject(MAT_DIALOG_DATA);
	private readonly assignment = this.data.assignment;
	public readonly loading = signal(false);
	public readonly canDeleteAssignments = hasPermission(this.session.permissions, 'Assignments.Delete');

	public async deleteDraft() {
		if (!this.canDeleteAssignments()) return;
		this.loading.set(true);

		try {
			await this.api.resetAssignment(this.assignment.clientId, this.assignment.id, DB_PHASES.P0);
			this.ntfy.addNotification(
				createSuccessNotification(this.transloco.translate('base.notification_message.assignment_draft_deleted')),
			);
			this.dialogRef.close(true);
		} catch {
			this.ntfy.addNotification(
				createErrorNotification(this.transloco.translate('base.notification_message.assignment_draft_delete_error')),
			);
		} finally {
			this.loading.set(false);
		}
	}
}
